import React, { useEffect, useState } from 'react'

const ChangeTheme = () => {

    const themes = ["default", "theme1", "theme2"]
    const [currentTheme, setCurrentTheme] = useState("")

    useEffect(() => {
        let theme = localStorage.getItem('theme');
        if (theme) setCurrentTheme(theme);
    },[])

    const handleThemeChange = (e) => {
        let theme = e.target.value
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('theme', theme);
        setCurrentTheme(theme)
    }

    return (
        <div className='theme-changer'>
            <p>Change Theme</p>
            <select value={currentTheme} onChange={handleThemeChange}>
                {
                    themes.map((item, index) => (
                        <option value={item} key={index}>{item}</option>
                    ))
                }
            </select>
        </div>
    )
}

export default ChangeTheme